import useDocumentDetails from "../../../../hooks/useDocumentDetails";
import Typography from "../../../../components/Typography";
import { ColorNames } from "../../../../theme";
import StateMap from "../../DocumentDetails/components/StateMap";
import Column from "../../../../components/Grid/Column";
import Row from "../../../../components/Grid/Row";
import CultureImages from "../components/CultureImages";
import { Hidden } from "react-grid-system";
import FarmerCard from "../../DocumentCards/FarmerCard";
import { FC } from "react";

const Summary: FC = () => {
  const { documentData } = useDocumentDetails();

  return (
    <>
      <Typography variant="h1" uppercase color={ColorNames.GREEN} align="left">
        Seguro rural
      </Typography>
      <Row justify="between" align="center">
        <Column xs={12} xl={8}>
          <Typography
            variant="textLarge"
            component="p"
            uppercase
            align="left"
            margin="sm"
          >
            Olá <strong>{documentData?.farmer?.name}</strong>, obrigado pelo seu
            interesse na contração do seguro agrícola. Analisamos suas
            informações e fizemos uma cotação indicativa para sua lavoura de{" "}
            <strong>{documentData?.crop?.cultureName}!</strong>
          </Typography>
          <Row justify="between" align="end">
            <Column xs={12} md={6}>
              <FarmerCard data={documentData} active={true} />
            </Column>
            <Hidden xs sm>
              <Column xs={12} md={6}>
                <StateMap
                  state={documentData?.property?.address?.state!}
                  height={250}
                />
              </Column>
            </Hidden>
          </Row>
        </Column>
        <Hidden xs sm md lg>
          <Column xs={12} xl={4}>
            <CultureImages cultureName={documentData?.crop?.cultureName!} />
          </Column>
        </Hidden>
      </Row>
    </>
  );
};

export default Summary;
